// extracted by mini-css-extract-plugin
export default {"articleTitle":"certificateFlow_articleTitle__qDBG1","pictureContainer":"certificateFlow_pictureContainer__5ahY+"};